/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Work_Meta_Layouttitle1Inputs */

const ja_work_meta_layouttitle1 = /** @type {(inputs: Work_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN | 実績紹介`)
};

const en_work_meta_layouttitle1 = /** @type {(inputs: Work_Meta_Layouttitle1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`PLAYBRAIN - Game Marketing & Esports Portfolio`)
};

/**
* | output |
* | --- |
* | "PLAYBRAIN - Game Marketing & Esports Portfolio" |
*
* @param {Work_Meta_Layouttitle1Inputs} inputs
* @param {{ locale?: "ja" | "en" }} options
* @returns {LocalizedString}
*/
const work_meta_layouttitle1 = /** @type {((inputs?: Work_Meta_Layouttitle1Inputs, options?: { locale?: "ja" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Work_Meta_Layouttitle1Inputs, { locale?: "ja" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "ja") return ja_work_meta_layouttitle1(inputs)
	return en_work_meta_layouttitle1(inputs)
});
export { work_meta_layouttitle1 as "work_meta_layoutTitle" }